
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dsflywlbtktdwaoodssp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRzZmx5d2xidGt0ZHdhb29kc3NwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAwNDA3NDMsImV4cCI6MjA1NTYxNjc0M30.FlrWoGvXZ2_j6LnpZ7G4V8VdDtjuNgeVDotgnloydHk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
